<template>
  <f7-list-item :swipeout="!tag.pseudo"
                :title="tag.name"
                @swipeout:delete="onDelete"
  >
    <f7-swipeout-actions right>
      <f7-swipeout-button @click="deleteClicked" color="red" overswipe>
        <f7-icon material="delete"/>
      </f7-swipeout-button>
    </f7-swipeout-actions>
    <f7-button slot="after"
               v-if="!tag.pseudo"
               icon-material="delete"
               color="red"
               @click="deleteClicked"
    />
    <f7-button v-else
               slot="after"
               icon-material="add"
               @click="addClicked"
               />
  </f7-list-item>
</template>

<script>
  export default {
    name: 'ManageTagsTag',
    props: {
      tag: {
        type: Object,
        required: true,
      },
    },
    methods: {
      confirmDelete () {
        return new Promise(resolve => {
          this.$f7.dialog.confirm(
            `Are you sure you want to archive the tag '${this.tag.name}'? This will not break requests that already use this tag.`,
            'Confirm Archival',
            () => resolve(true),
            () => resolve(false),
          )
        })
      },
      async onDelete () {
        await this.$store.dispatch('tags/archive', this.tag.id)
        await this.$store.dispatch('tags/fetch')
      },
      async deleteClicked (evt) {
        if (!await this.confirmDelete()) {
          return
        }
        const li = evt.target.closest('li')
        this.$f7.swipeout.delete(li, this.onDelete)
      },
      async addClicked () {
        await this.$store.dispatch('tags/add', this.tag.name)
        await this.$store.dispatch('tags/fetch')
      },
    },
  }
</script>

<style scoped>

</style>
